/**
 * Custom free-shipping progress bar.
 * Refreshes every instance of .m-free-shipping-bar (cart drawer + /cart page)
 * whenever the Minimog cart-update pub/sub events fire, by re-fetching /cart.js.
 * Threshold must match snippets/free-shipping-bar.liquid.
 */
(function () {
  if (window.__minimogFreeShippingBarInit) return;
  window.__minimogFreeShippingBarInit = true;

  var THRESHOLD = 129900; // ₹1,299 in paise — keep in sync with the liquid snippet

  function formatINR(paise) {
    var rupees = Math.max(0, Math.round(paise / 100));
    var str = String(rupees);
    var lastThree = str.substring(str.length - 3);
    var rest = str.substring(0, str.length - 3);
    if (rest !== '') {
      lastThree = ',' + lastThree;
    }
    var formattedRest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return '₹' + formattedRest + lastThree;
  }

  function render(cart) {
    var bars = document.querySelectorAll('.m-free-shipping-bar');
    if (!bars.length) return;

    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var remaining = THRESHOLD - total;
    var progress = Math.min(100, Math.max(0, Math.floor((total / THRESHOLD) * 100)));
    var unlocked = remaining <= 0;

    bars.forEach(function (bar) {
      bar.classList.toggle('m-free-shipping-bar--unlocked', unlocked);

      var fill = bar.querySelector('.m-free-shipping-bar__fill');
      if (fill) fill.style.width = progress + '%';

      var track = bar.querySelector('.m-free-shipping-bar__track');
      if (track) track.setAttribute('aria-valuenow', String(progress));

      var message = bar.querySelector('.m-free-shipping-bar__message');
      if (message) {
        message.innerHTML = unlocked
          ? '🎉 You’ve unlocked <strong>Free Delivery!</strong>'
          : 'Add <strong>' + formatINR(remaining) + '</strong> more to unlock <strong>Free Delivery!</strong>';
      }
    });
  }

  function refresh() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  }

  function subscribeWhenReady() {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, refresh);
      if (window.MinimogTheme.pubSubEvents.openCartDrawer) {
        window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, refresh);
      }
    } else {
      // Theme event bus not ready yet — retry shortly rather than silently no-op.
      setTimeout(subscribeWhenReady, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    subscribeWhenReady();
  });
})();
